import React from 'react';
import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';
import { Checkbox, CheckboxGroup } from '../../../components/ui/Checkbox';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const FilterPanel = ({ filters, onFilterChange, onReset, onApply }) => {
  const categoryOptions = [
    { value: 'all', label: 'All Categories' },
    { value: 'biodiversity', label: 'Biodiversity Data' },
    { value: 'climate', label: 'Climate & Weather' },
    { value: 'species', label: 'Species Monitoring' },
    { value: 'habitat', label: 'Habitat Assessment' },
    { value: 'threats', label: 'Threat Analysis' },
    { value: 'conservation', label: 'Conservation Impact' }
  ];

  const accessLevelOptions = [
    { value: 'all', label: 'All Access Levels' },
    { value: 'public', label: 'Public' },
    { value: 'restricted', label: 'Restricted' },
    { value: 'confidential', label: 'Confidential' }
  ];

  const formatOptions = [
    { value: 'all', label: 'All Formats' },
    { value: 'csv', label: 'CSV' },
    { value: 'json', label: 'JSON' },
    { value: 'xlsx', label: 'Excel (XLSX)' },
    { value: 'geojson', label: 'GeoJSON' },
    { value: 'shp', label: 'Shapefile' },
    { value: 'pdf', label: 'PDF' }
  ];

  const dateRangeOptions = [
    { value: 'all', label: 'All Time' },
    { value: 'week', label: 'Last Week' },
    { value: 'month', label: 'Last Month' },
    { value: 'quarter', label: 'Last Quarter' },
    { value: 'year', label: 'Last Year' },
    { value: 'custom', label: 'Custom Range' }
  ];

  return (
    <div className="bg-[var(--color-card)] rounded-lg p-6 border border-[var(--color-border)]">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-lg font-semibold text-[var(--color-card-foreground)] flex items-center gap-2">
          <Icon name="Filter" size={20} />
          Advanced Filters
        </h3>
        <Button 
          variant="ghost" 
          size="sm"
          iconName="RotateCcw"
          onClick={onReset}
        >
          Reset
        </Button>
      </div>
      <div className="space-y-6">
        <Input
          label="Search Keywords"
          type="search"
          placeholder="Search datasets..."
          value={filters?.search}
          onChange={(e) => onFilterChange('search', e?.target?.value)}
        />

        <Select
          label="Category"
          options={categoryOptions}
          value={filters?.category}
          onChange={(value) => onFilterChange('category', value)}
        />

        <Select
          label="Access Level"
          options={accessLevelOptions}
          value={filters?.accessLevel}
          onChange={(value) => onFilterChange('accessLevel', value)}
        />

        <Select
          label="File Format"
          options={formatOptions}
          value={filters?.format}
          onChange={(value) => onFilterChange('format', value)}
        />

        <Select
          label="Date Range"
          options={dateRangeOptions}
          value={filters?.dateRange}
          onChange={(value) => onFilterChange('dateRange', value)}
        />

        {filters?.dateRange === 'custom' && (
          <div className="grid grid-cols-2 gap-4">
            <Input
              label="Start Date"
              type="date"
              value={filters?.startDate}
              onChange={(e) => onFilterChange('startDate', e?.target?.value)}
            />
            <Input
              label="End Date"
              type="date"
              value={filters?.endDate}
              onChange={(e) => onFilterChange('endDate', e?.target?.value)}
            />
          </div>
        )}

        <CheckboxGroup label="Data Quality">
          <Checkbox 
            label="Peer-reviewed"
            checked={filters?.peerReviewed}
            onChange={(e) => onFilterChange('peerReviewed', e?.target?.checked)}
          />
          <Checkbox 
            label="Validated"
            checked={filters?.validated}
            onChange={(e) => onFilterChange('validated', e?.target?.checked)}
          />
          <Checkbox 
            label="Published"
            checked={filters?.published}
            onChange={(e) => onFilterChange('published', e?.target?.checked)}
          />
        </CheckboxGroup>

        <div>
          <label className="block text-sm font-medium text-[var(--color-card-foreground)] mb-2">
            File Size Range (MB)
          </label>
          <div className="grid grid-cols-2 gap-4">
            <Input
              type="number"
              placeholder="Min"
              value={filters?.minSize}
              onChange={(e) => onFilterChange('minSize', e?.target?.value)}
            />
            <Input
              type="number"
              placeholder="Max"
              value={filters?.maxSize}
              onChange={(e) => onFilterChange('maxSize', e?.target?.value)}
            />
          </div>
        </div>

        <Button 
          variant="default" 
          fullWidth
          iconName="Search"
          iconPosition="left"
          onClick={onApply}
        >
          Apply Filters
        </Button>
      </div>
    </div>
  );
};

export default FilterPanel;